"use strict";

angular.module("customer")
.directive("promotionCatalogEntry", function() {
    return {
        restrict: "E",
        templateUrl: require("./promotion-catalog-entry.directive.html"),
        controller: PromotionCatalogEntryController,
        controllerAs: "promotionCatalogEntryCtrl"
    };
});

function PromotionCatalogEntryController($scope, $state) {
    this.onClick = function(instance) {
        if ($scope.slick.shouldClick) {
            $state.go("stocks", {
                product: instance.id
            });
        }
    };
}



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/promotion-catalog-entry/promotion-catalog-entry.directive.js
// module id = 845
// module chunks = 0